export const Pills = {
	ErrorFilled: 'errorFilled',
	SuccessFilled: 'successFilled',
	SecondaryFilled: 'secondaryFilled',
	SecondaryLightFilled: 'secondaryLightFilled',
	SecondaryOutline: 'secondaryOutline',
} as const;
